import React from "react";
import { Card, CardBody, Button, Input, Textarea, addToast } from "@heroui/react";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";
import api from "../services/api";

const ContactForm: React.FC = () => {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [isSent, setIsSent] = React.useState(false);

  const validate = () => {
    if (!name.trim()) return false;
    if (!email.trim() || !/^\S+@\S+\.\S+$/.test(email)) return false;
    if (!message.trim()) return false;
    return true;
  };

  const handleSubmit = async (e?: React.FormEvent) => {
    if (e) e.preventDefault();
    if (!validate()) {
      addToast({ title: "Ошибка", description: "Пожалуйста, заполните все поля корректно.", color: "danger" });
      return;
    }

    setIsSubmitting(true);
    try {
      const payload = {
        name: name.trim(),
        email: email.trim(),
        message: message.trim(),
      };

      await api.post('/contact/', payload, { headers: { 'Content-Type': 'application/json' } });

      addToast({ title: "Сообщение отправлено", description: "Спасибо! Мы свяжемся с вами в ближайшее время.", color: "success" });
      setIsSent(true);
      // keep fields cleared
      setName("");
      setEmail("");
      setMessage("");
    } catch (err: any) {
      console.error('Contact send error', err);
      const msg = err?.response?.data?.message || err?.message || 'Неизвестная ошибка';
      addToast({ title: "Ошибка отправки", description: msg, color: "danger" });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isSent) {
    return (
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-center py-12">
        <div className="bg-primary/10 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
          <Icon icon="lucide:check" className="text-primary" width={32} />
        </div>
        <h4 className="text-xl font-medium mb-2">Спасибо за ваше сообщение!</h4>
        <p className="text-foreground/70">Мы свяжемся с вами в ближайшее время.</p>
      </motion.div>
    );
  }

  return (
    <Card className="border border-divider bg-content2/50" disableRipple>
      <CardBody className="p-8">
        <form onSubmit={handleSubmit} className="space-y-6">
          <Input
            type="text"
            label="Имя"
            placeholder="Введите ваше имя"
            variant="bordered"
            isRequired
            value={name}
            onValueChange={(v: string) => setName(v)}
          />
          <Input
            type="email"
            label="Email"
            placeholder="Введите ваш email"
            variant="bordered"
            isRequired
            value={email}
            onValueChange={(v: string) => setEmail(v)}
          />
          <Textarea
            label="Сообщение"
            placeholder="Опишите ваш запрос или вопрос"
            variant="bordered"
            isRequired
            minRows={4}
            value={message}
            onValueChange={(v: string) => setMessage(v)}
          />
          <Button type="submit" color="primary" size="lg" className="w-full" isLoading={isSubmitting}>
            Отправить сообщение
          </Button>
        </form>
      </CardBody>
    </Card>
  );
};

export default ContactForm;
